module.exports = __webpack_public_path__ + "static/media/27@2x.3105f6ca.png";